import React, { createContext, useContext } from "react";

export type BookmarkType = {
  mlsnums: string[];
};

type BookmarkContextType = {
  bookmark: BookmarkType | null;
  setBookmark: React.Dispatch<React.SetStateAction<BookmarkType | null>>;
};

export const BookmarkContext = createContext<BookmarkContextType | undefined>(
  undefined
);

// Custom hook to use the UserContext
export const useBookmarkContext = () => {
  const context = useContext(BookmarkContext);
  if (!context) {
    throw new Error("useBookmarkContext must be used within a BookmarkContextProvider");
  }
  return context;
};
